import { useContext } from "react";
import {
  DeveloperContext,
  DeveloperContextValue,
} from "../context/DeveloperContext";

export const useDeveloperContext = () => {
  const context = useContext(DeveloperContext) as DeveloperContextValue;
  if (!context) {
    throw new Error(
      "Make sure to only call useUpcxChain within a  <DeveloperProvider>"
    );
  }
  return context;
};
